import * as React from 'react';

import {ActionMenu} from 'shells/action-menu/action-menu';
import {Dialog} from 'shells/dialog/dialog';
// @ts-expect-error - imported from .js/.jsx file
import {TrashIcon} from 'shells/icon/svg/trash-icon';

type Props = {
    assigneeToUnassign: string;
    onConfirm: () => void;
};

export function UnassignActionMenu(props: Props) {
    const [isConfirmingUnassign, setIsConfirmingUnassign] = React.useState(false);

    const menuRef = React.useRef(null);

    const options = [
        {
            label: 'Unassign',
            icon: <TrashIcon size={16} />,
            variant: 'destructive',
            handleSelect: () => {
                setIsConfirmingUnassign(true);
            },
        },
    ];

    return (
        <>
            <div className='pr-8'>
                <ActionMenu
                    getRef={(node) => {
                        // @ts-expect-error
                        menuRef.current = node;
                    }}
                    // @ts-expect-error
                    options={options}
                    size='small'
                    padding='none'
                />
            </div>
            {isConfirmingUnassign && (
                <Dialog
                    anchor={menuRef.current}
                    location='top'
                    question={`Are you sure you want to unassign ${props.assigneeToUnassign}?`}
                    primaryText='Yes, unassign'
                    secondaryText='Cancel'
                    onPrimary={() => {
                        props.onConfirm();
                        setIsConfirmingUnassign(false);
                    }}
                    onSecondary={() => setIsConfirmingUnassign(false)}
                    isWarning={true}
                />
            )}
        </>
    );
}
